import React, { useMemo, useState } from 'react'
import { Button, Tabs } from 'antd'
import { FaSuitcase } from "react-icons/fa";
import { FaSuitcaseRolling } from "react-icons/fa";
import { FaBowlRice } from 'react-icons/fa6';
import { MdAirlineSeatReclineNormal } from 'react-icons/md';
import AirplaneSeatTripjack from './AirplaneSeatTripjack';
const { TabPane } = Tabs;


const AddonsFlightTripJack = ({
    setSelectFlightSeat,
    flightDetails,
    selectedBaggages,
    addBaggage,
    removeBaggage,
    totalSelectMeals,
    addMeal,
    removeMeal,
    selectedMeals,
    loading,
    selectedMealsReturn,
    addMealReturn,
    mealTotalAmountRetrun,
    removeMealReturn,
    addBaggageReturn,
    removeBaggageReturn,
    selectedBaggagesReturn,
    skipAddonAndPayNow,
    totalSeatPrice,
    setTotalSeatPrice,
    selectedSeats,
    setSelectedSeats,
    seatsList,
    setSeatsList,

    totalSeatsPriceReturn,
    setTotalSeatPriceReturn,
    selectedSeatsReturn,
    setSelectedSeatsReturn,
    seatsListReturn,
    setSeatsListReturn,

    setSelectedMeals,
    setMealTotalAmount,
    setSelectedMealsReturn,
    setMealTotalAmountReturn,
    setSelectedBaggages,
    setSelectedBaggagesReturn,
    setTotalAmountBaggageReturn,
    setTotalAmount,

}) => {
    const totalSelectedBaggages = selectedBaggages.length;
    const totalSelectedBaggagesReturn = selectedBaggagesReturn.length

    const handleSeatClick = (seat, flightKey) => {
        const seatCode = seat.Code || seat.code;
        const seatPrice = seat.Price || seat.amount || 0;
        const seatAvailable = seat.Available ?? seat.available;

        const currentSeats = selectedSeats[flightKey] || [];
        const isSelected = currentSeats.find((s) => s.Code === seatCode);

        if (!seatAvailable && !isSelected) return;

        const updatedSelectedSeats = { ...selectedSeats };

        if (isSelected) {
            const updatedSeats = currentSeats.filter((s) => s.Code !== seatCode);
            updatedSelectedSeats[flightKey] = updatedSeats;
            if (updatedSeats.length === 0) {
                delete updatedSelectedSeats[flightKey];
            }
        } else {
            let updatedSeats = [...currentSeats, { ...seat, Code: seatCode }];

            if (totalSelectMeals === 1) {
                updatedSeats = [{ ...seat, Code: seatCode }];
            } else if (currentSeats.length >= totalSelectMeals) {
                updatedSeats = [...currentSeats.slice(1), { ...seat, Code: seatCode }];
            }
            updatedSelectedSeats[flightKey] = updatedSeats;
        }

        setSelectedSeats(updatedSelectedSeats);
        const totalPrice = Object.values(updatedSelectedSeats).flat().reduce(
            (sum, seat) => sum + (seat.Price || seat.amount || 0),
            0
        );
        setTotalSeatPrice(totalPrice);
        const allSeatsArray = Object.entries(updatedSelectedSeats).flatMap(
            ([key, seats]) => {
                const [from, to] = key.split(" - ").map((s) => s.trim());
                return seats.map((s) => ({
                    origin: from,
                    destination: to,
                    code: s.Code,
                    price: s.Price || s.amount || 0,
                    description: s.Code,
                }));
            }
        );
        setSeatsList(allSeatsArray);
    };


    const handleSeatClickReturn = (seat, flightKey) => {
        const seatCode = seat.Code || seat.code;
        const seatPrice = seat.Price || seat.amount || 0;
        const seatAvailable = seat.Available ?? seat.available;

        const currentSeats = selectedSeatsReturn[flightKey] || [];
        const isSelected = currentSeats.find((s) => s.Code === seatCode);

        if (!seatAvailable && !isSelected) return;

        const updatedSelectedSeats = { ...selectedSeatsReturn };

        if (isSelected) {
            const updatedSeats = currentSeats.filter((s) => s.Code !== seatCode);
            updatedSelectedSeats[flightKey] = updatedSeats;

            // Remove flight key if no seats selected
            if (updatedSeats.length === 0) {
                delete updatedSelectedSeats[flightKey];
            }
        } else {
            let updatedSeats = [...currentSeats, { ...seat, Code: seatCode }];

            if (totalSelectMeals === 1) {
                updatedSeats = [{ ...seat, Code: seatCode }];
            } else if (currentSeats.length >= totalSelectMeals) {
                updatedSeats = [...currentSeats.slice(1), { ...seat, Code: seatCode }];
            }
            updatedSelectedSeats[flightKey] = updatedSeats;
        }

        setSelectedSeatsReturn(updatedSelectedSeats);

        // Calculate total price from all selected seats
        const totalPrice = Object.values(updatedSelectedSeats).flat().reduce(
            (sum, seat) => sum + (seat.Price || seat.amount || 0),
            0
        );
        setTotalSeatPriceReturn(totalPrice);
        const allSeatsArray = Object.entries(updatedSelectedSeats).flatMap(
            ([key, seats]) => {
                const [from, to] = key.split(" - ").map((s) => s.trim());
                return seats.map((s) => ({
                    origin: from,
                    destination: to,
                    code: s.Code,
                    price: s.Price || s.amount || 0,
                    description: s.Code,
                }));
            }
        );
        setSeatsListReturn(allSeatsArray);
    };

    const transformSeatData = (seatData, legendData, flightInfo) => {
        if (!seatData || !Array.isArray(seatData)) return {};

        const rowsByFlight = {};
        const legends = {};
        const rows = {};
        seatData.forEach(seat => {
            if (!seat.seatPosition) return;

            const rowNum = seat.seatPosition.row;
            if (!rows[rowNum]) {
                rows[rowNum] = {
                    RowNumber: rowNum,
                    Seats: []
                };
            }

            const transformedSeat = {
                Code: seat.code,
                SeatNo: seat.seatNo.replace(rowNum.toString(), ''),
                SeatCategory: seat.SeatCategory,
                Available: seat.available && !seat.isBooked,
                ColorCode: seat.ColorCode,
                ColorName: seat.ColorName,
                Price: seat.amount,
                IsBooked: seat.isBooked,
                IsLegroom: seat.isLegroom,
                AvailabilityTypeLabel: seat.availability_type_label
            };

            rows[rowNum].Seats.push(transformedSeat);
        });
        const sortedRows = Object.values(rows).sort((a, b) => a.RowNumber - b.RowNumber);
        const origin = flightInfo?.da?.cityCode || '';
        const destination = flightInfo?.aa?.cityCode || '';
        const flightKey = `${origin} - ${destination}`;

        rowsByFlight[flightKey] = sortedRows;

        if (legendData && Array.isArray(legendData)) {
            legends[flightKey] = {
                legend: legendData.map(item => ({
                    label: item.label,
                    color: item.color
                }))
            };
        }

        return { rowsByFlight, legends };
    };

    const [activeTab, setActiveTab] = useState("1");
    const [activeTabReturn, setActiveTabReturn] = useState("1");


    const getAvailableTabs = (tripIndex) => {
        const ssrInfo = flightDetails?.tripInfos?.[tripIndex]?.sI?.[0]?.ssrInfo || {};
        const tabs = [];
        if (ssrInfo.SEAT?.length) tabs.push("1");
        if (ssrInfo.MEAL?.length) tabs.push("2");
        if (ssrInfo.BAGGAGE?.length) tabs.push("3");
        return tabs;
    };

    const availableTabs = getAvailableTabs(0);
    const availableTabsReturn = getAvailableTabs(1);

    const getNextTab = (currentKey, availableTabList) => {
        const currentIndex = availableTabList.indexOf(currentKey);
        if (currentIndex === -1 || currentIndex === availableTabList.length - 1) return null;
        return availableTabList[currentIndex + 1];
    };

    const resetTabData = (tabKey, isReturn = false) => {
        if (!isReturn) {
            // 🟦 Onward Reset
            switch (tabKey) {
                case "1":
                    setSelectedSeats({});
                    setSeatsList([]);
                    setTotalSeatPrice(null);
                    break;
                case "2":
                    setSelectedMeals([]);
                    setMealTotalAmount(0);
                    break;
                case "3":
                    setSelectedBaggages([]);
                    setTotalAmount(0);
                    break;
                default:
                    break;
            }
        } else {
            // 🟩 Return Reset
            switch (tabKey) {
                case "1":
                    setSelectedSeatsReturn({});
                    setSeatsListReturn([]);
                    setTotalSeatPriceReturn(null);
                    break;
                case "2":
                    setSelectedMealsReturn([]);
                    setMealTotalAmountReturn(0);
                    break;
                case "3":
                    setSelectedBaggagesReturn([]);
                    setTotalAmountBaggageReturn(0);
                    break;
                default:
                    break;
            }
        }
    };

    const handleSkip = (tabKey, isReturn = false) => {
        const availableTabList = isReturn ? availableTabsReturn : availableTabs;
        const setActiveTabFn = isReturn ? setActiveTabReturn : setActiveTab;
        resetTabData(tabKey, isReturn);
        const nextTab = getNextTab(tabKey, availableTabList);
        if (nextTab) {
            setActiveTabFn(nextTab);
        } else {
            console.log("✅ No more tabs — Proceed to next step (e.g. payment)");
        }
    };

    const handleSkipSeats = () => handleSkip("1", false);
    const handleSkipMeals = () => handleSkip("2", false);
    const handleSkipBaggage = () => handleSkip("3", false);

    const handleSkipSeatsReturn = () => handleSkip("1", true);
    const handleSkipMealsReturn = () => handleSkip("2", true);
    const handleSkipBaggageReturn = () => handleSkip("3", true);

    const hasSeats = flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.SEAT?.length > 0;

    return (
        <>
            <div className={`card mt-2 flights-seat mb-md-3 mb-2`}>
                <div className="bg-white rounded-3 pb-3">

                    <Tabs
                        className='px-3'
                        defaultActiveKey="1"
                        tabBarExtraContent={
                            <button
                                style={{ background: "transparent", border: "none" }}
                                onClick={skipAddonAndPayNow}
                                className="btn btn-light text-danger"
                            >
                                <b>Skip addons</b>
                            </button>
                        }
                        activeKey={activeTab}
                        onChange={setActiveTab}
                    >

                        {flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.SEAT?.length && (
                            <TabPane
                                tab={<h4 className="mb-1">
                                    <MdAirlineSeatReclineNormal className="AddonsIcon" /> Seats </h4>}
                                key="1"
                                className='mb-0'
                            >

                                {hasSeats && (
                                    <Tabs
                                        defaultActiveKey="0"
                                        className="meal-tabs"
                                        type="card"
                                        tabBarExtraContent={
                                            <button
                                                style={{ background: "transparent", border: "none" }}
                                                onClick={handleSkipSeats}
                                                className="btn btn-light text-danger"
                                            >
                                                <b>Skip Seats</b>
                                            </button>
                                        }

                                    >
                                        {flightDetails?.tripInfos?.[0]?.sI.map((flightInfo, flightIndex) => {
                                            const segmentList = flightDetails?.tripInfos?.[0]?.sI;
                                            const seats = flightInfo?.ssrInfo?.SEAT || [];
                                            const legends = flightInfo?.ssrInfo?.SEAT_LEGEND || [];

                                            if (seats.length === 0) return null;

                                            const origin = flightInfo?.da?.city || flightInfo?.da?.code || '';
                                            const destination = flightInfo?.aa?.city || flightInfo?.aa?.code || '';
                                            const originCityCode = flightInfo?.da?.cityCode || '';
                                            const destinationCityCode = flightInfo?.aa?.cityCode || '';
                                            const { rowsByFlight, legends: transformedLegends } = transformSeatData(seats, legends, flightInfo);
                                            const flightKey = `${originCityCode} - ${destinationCityCode}`;
                                            const selectedSeatsCount = selectedSeats[flightKey]?.length || 0;

                                            return (
                                                <TabPane
                                                    tab={
                                                        <div className="mb-0">
                                                            <div className="card-body p-2">
                                                                <div className="d-flex justify-content-start">
                                                                    <div className="d-end fl-title ps-2">
                                                                        <div className="fw-bold">{`${origin} - ${destination}`}</div>
                                                                        <div className="text-sm">
                                                                            <span className="text-danger fw-bold">{selectedSeatsCount}</span> of {totalSelectMeals} Seats selected
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    key={flightIndex}
                                                >
                                                    <AirplaneSeatTripjack
                                                        totalSelectedTravellers={totalSelectMeals}
                                                        rowsByFlight={rowsByFlight}
                                                        legends={transformedLegends}
                                                        selectedSeats={selectedSeats}
                                                        onClick={handleSeatClick}
                                                        skipSeats={handleSkipSeats}
                                                        flightInfo={flightInfo}
                                                    />
                                                </TabPane>
                                            );
                                        })}
                                    </Tabs>
                                )}
                            </TabPane>
                        )}

                        {flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.MEAL?.length && (
                            <TabPane tab={<h4 className="mb-1">  <FaBowlRice className="AddonsIcon" /> Meals </h4>}
                                key="2"
                                className='mb-0'
                            >

                                {flightDetails?.tripInfos?.[0]?.sI[0]?.ssrInfo?.MEAL?.length !== 0 && (
                                    <Tabs
                                        defaultActiveKey="0"
                                        className="meal-tabs"
                                        type="card"

                                        tabBarExtraContent={
                                            <button
                                                style={{ background: "transparent", border: "none" }}
                                                onClick={handleSkipMeals}
                                                className="btn btn-light text-danger"
                                            >
                                                <b>Skip Meals</b>
                                            </button>
                                        }
                                    >
                                        {flightDetails?.tripInfos?.[0]?.sI.map((flightInfo, flightIndex) => {
                                            const segmentList = flightDetails?.tripInfos?.[0]?.sI;
                                            const meals = flightInfo?.ssrInfo?.MEAL || [];
                                            if (meals.length === 0) return null;
                                            const origin = flightInfo?.da?.city || flightInfo?.da?.code || '';
                                            const destination = flightInfo?.aa?.city || flightInfo?.aa?.code || '';
                                            const selectedCount = selectedMeals?.[flightIndex]?.selectedMeals?.length || 0;
                                            return (
                                                <TabPane
                                                    tab={
                                                        // segmentList?.length > 1 ? (
                                                        <div className="mb-0">
                                                            <div className="card-body p-2">
                                                                <div className="d-flex justify-content-start">
                                                                    <div className="d-end fl-title ps-2">
                                                                        <div className="fw-bold">{`${origin} - ${destination}`}</div>
                                                                        <div className="text-sm">
                                                                            <span className="text-danger fw-bold">{selectedCount}</span> of {totalSelectMeals} Meals selected
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        // ) : null
                                                    }

                                                    key={flightIndex}
                                                >
                                                    {flightInfo?.ssrInfo?.MEAL?.length > 0 && (
                                                        <>
                                                            {/* {segmentList?.length <= 1 && (<div className="card">
                                                                <div className="card-body p-2">
                                                                    <div className="d-flex justify-content-start">
                                                                        <div className="d-start fl-pic">
                                                                            <img
                                                                                className="img-collection result-flight"
                                                                                src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${flightInfo?.fD?.aI?.code}.gif`}
                                                                                alt="logo"
                                                                            />
                                                                        </div>
                                                                        <div className="d-end fl-title ps-2">
                                                                            <div className="text-dark fw-bold">
                                                                                {flightInfo?.da?.city} - {flightInfo?.aa?.city}
                                                                            </div>
                                                                            <div className="text-sm text-muted">
                                                                                <span className="text-danger">
                                                                                    {selectedMeals?.[flightIndex]?.selectedMeals?.length || 0}
                                                                                </span>{" "}
                                                                                of <span className="text-dark">{totalSelectMeals}</span> Meals selected
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>)} */}


                                                            <div className="overflow-auto p-2 border rounded" style={{ maxHeight: "260px" }}>
                                                                {flightInfo?.ssrInfo?.MEAL.map((meal, mealIndex) => (
                                                                    <div className="d-flex align-items-center justify-content-between mb-3" key={mealIndex}>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1">
                                                                                <svg fill="#ffffff" height="20px" width="20px" version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_3_" d="M198.5,127h56.8c-3.1,51.4-36.3,94.5-82.3,111.7V256H83v-17.3C37,221.5,3.8,178.4,0.7,127h155.1l87.5-68.1 c3.5-2.7,8.5-2.1,11.2,1.4s2.1,8.5-1.4,11.2c-0.1,0.1-0.3,0.2-0.4,0.3l-81,55.1l73-36.2c4-2,8.8-0.3,10.7,3.6c2,4,0.3,8.8-3.6,10.7 c-0.2,0.1-0.3,0.2-0.5,0.2L198.5,127z M163.6,79.4c0,7.8,3.2,12,5.7,15.3c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1 c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9 c2.5-3.3,5.7-7.5,5.7-15.3s-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9 c0,4.8-1.6,6.9-3.9,9.9C166.7,67.4,163.6,71.6,163.6,79.4z M115.7,71c0,11.2,4.4,16.9,8.3,22c1.2,1.5,2.2,2.9,3.2,4.5 c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-1.2-1.9-2.5-3.6-3.7-5.2c-3.4-4.5-6.4-8.4-6.4-16.5 s3-12,6.4-16.5c3.9-5.1,8.3-10.8,8.3-22c0-11.1-4.4-16.9-8.3-22l-0.7-0.9c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.7,1 c3.4,4.5,6.4,8.4,6.4,16.5c0,8.1-3,12-6.4,16.5C120.1,54.1,115.7,59.9,115.7,71z M72.9,79.4c0,7.8,3.2,12,5.7,15.3 c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5 c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9c2.5-3.3,5.7-7.5,5.7-15.3c0-7.8-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9 c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9c0,4.8-1.6,6.9-3.9,9.9C76.1,67.4,72.9,71.6,72.9,79.4z"></path> </g></svg>
                                                                            </div>
                                                                            <div className="ms-2">
                                                                                <h4 className="mb-0 line-height">{meal?.desc}</h4>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center addons_button">
                                                                            <div className="fw-bold">₹{meal?.amount}</div>

                                                                            <Button
                                                                                className="btn btn-danger py-0 px-md-4 rounded ms-2"
                                                                                onClick={() => removeMeal(flightIndex, mealIndex, meal.amount, flightInfo)}
                                                                                disabled={!selectedMeals?.[flightIndex]?.selectedMeals?.some(selected => selected.mealIndex === mealIndex)}
                                                                                aria-label="remove meal"
                                                                            >
                                                                                -
                                                                            </Button>
                                                                            <span className="ms-2">
                                                                                {selectedMeals?.[flightIndex]?.selectedMeals?.filter(selected => selected.mealIndex === mealIndex).length || 0}
                                                                            </span>
                                                                            <Button
                                                                                className="btn btn-primary py-0 px-md-4 rounded ms-2"
                                                                                onClick={() => addMeal(flightIndex, mealIndex, meal.amount, meal, flightInfo)}
                                                                                disabled={selectedMeals?.[flightIndex]?.selectedMeals?.length >= totalSelectMeals}
                                                                                aria-label="add meal"
                                                                            >
                                                                                +
                                                                            </Button>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                        </>
                                                    )}
                                                </TabPane>
                                            );
                                        })}
                                    </Tabs>
                                )}
                            </TabPane>
                        )}

                        {flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.BAGGAGE && (
                            <TabPane
                                tab={<h4 className="mb-1"> <FaSuitcaseRolling className="AddonsIcon" /> Baggage </h4>}
                                key="3"
                            >
                                {(flightDetails?.tripInfos?.[0]?.sI[0]?.ssrInfo?.BAGGAGE || []).length !== 0 &&
                                    <>
                                        <div className='d-flex justify-content-between align-items-center mb-3'>
                                            <div className='card'>
                                                <div className='card-body p-2'>
                                                    <div className="d-flex justify-content-start">
                                                        <div className="d-end fl-title ps-2">
                                                            <div className="text-dark fw-bold">{flightDetails?.tripInfos?.[0]?.daCity} - {flightDetails?.tripInfos?.[0]?.aaCity}</div>
                                                            <div className="text-sm text-muted"><span className="text-danger">{totalSelectedBaggages}</span> of <span className="text-dark">{totalSelectMeals}</span> baggage selected</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <button
                                                style={{ background: "transparent", border: "none" }}
                                                onClick={handleSkipBaggage}
                                                className="btn btn-light text-danger"
                                            >
                                                <b>Skip Baggages</b>
                                            </button>
                                        </div>

                                        <div className="overflow-auto p-2 border rounded" style={{ maxHeight: "260px" }}>

                                            {flightDetails?.tripInfos?.[0]?.sI?.[0]?.ssrInfo?.BAGGAGE?.map((baggage, i) => (
                                                <div className="d-flex align-items-center justify-content-between mb-3" key={i}>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1'>
                                                            <FaSuitcase className='text-white fs-4' />
                                                        </div>
                                                        <div className='ms-2'>
                                                            <h4 className='mb-0 line-height'>{baggage?.desc}</h4>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex align-items-center addons_button'>
                                                        <div className='fw-bold'>₹{baggage?.amount}</div>

                                                        <Button
                                                            className='btn btn-danger py-0 px-md-4 rounded ms-2'
                                                            onClick={() => removeBaggage(baggage, flightDetails?.tripInfos)}
                                                        >
                                                            -
                                                        </Button>

                                                        <span className="ms-2">
                                                            {
                                                                selectedBaggages.filter(
                                                                    item =>
                                                                        item.code === baggage.code &&
                                                                        item.origin === flightDetails?.tripInfos?.[0]?.sI?.[0]?.da?.code &&
                                                                        item.destination === flightDetails?.tripInfos?.[0]?.sI?.[0]?.aa?.code
                                                                ).length
                                                            }
                                                        </span>

                                                        <Button
                                                            className='btn btn-primary py-0 px-md-4 rounded ms-2'
                                                            onClick={() => addBaggage(baggage, flightDetails?.tripInfos)}
                                                            disabled={selectedBaggages.length >= totalSelectMeals}
                                                        >
                                                            +
                                                        </Button>

                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                }
                            </TabPane>
                        )}
                    </Tabs>

                    {(
                        flightDetails?.tripInfos?.[1]?.sI?.[0]?.ssrInfo?.MEAL?.length ||
                        flightDetails?.tripInfos?.[1]?.sI?.[0]?.ssrInfo?.SEAT?.length ||
                        flightDetails?.tripInfos?.[1]?.sI?.[0]?.ssrInfo?.BAGGAGE?.length
                    )
                        &&
                        <>
                            <hr className='mb-4 mt-4' style={{ border: "1px solid #f0f1f3" }} />
                            <Tabs
                                className='px-3'
                                defaultActiveKey="1"
                                activeKey={activeTabReturn}
                                onChange={setActiveTabReturn}
                            >

                                {flightDetails?.tripInfos?.[1]?.sI?.[0]?.ssrInfo?.SEAT?.length && (
                                    <TabPane
                                        tab={<h4 className="mb-1">
                                            <MdAirlineSeatReclineNormal className="AddonsIcon" /> Seats </h4>}
                                        key="1"
                                        className='mb-0'
                                    >
                                        <Tabs
                                            defaultActiveKey="0"
                                            className="meal-tabs"
                                            type="card"
                                            tabBarExtraContent={
                                                <button
                                                    style={{ background: "transparent", border: "none" }}
                                                    onClick={handleSkipSeatsReturn}
                                                    className="btn btn-light text-danger"
                                                >
                                                    <b>Skip Seats</b>
                                                </button>
                                            }
                                        >
                                            {flightDetails?.tripInfos?.[1]?.sI.map((flightInfo, flightIndex) => {
                                                const segmentList = flightDetails?.tripInfos?.[0]?.sI;
                                                const seats = flightInfo?.ssrInfo?.SEAT || [];
                                                const legends = flightInfo?.ssrInfo?.SEAT_LEGEND || [];

                                                if (seats.length === 0) return null;

                                                const origin = flightInfo?.da?.city || flightInfo?.da?.code || '';
                                                const destination = flightInfo?.aa?.city || flightInfo?.aa?.code || '';
                                                const originCityCode = flightInfo?.da?.cityCode || '';
                                                const destinationCityCode = flightInfo?.aa?.cityCode || '';
                                                const { rowsByFlight, legends: transformedLegends } = transformSeatData(seats, legends, flightInfo);
                                                const flightKey = `${originCityCode} - ${destinationCityCode}`;
                                                const selectedSeatsCount = selectedSeatsReturn[flightKey]?.length || 0;

                                                return (
                                                    <TabPane
                                                        tab={
                                                            <div className="mb-0">
                                                                <div className="card-body p-2">
                                                                    <div className="d-flex justify-content-start">
                                                                        <div className="d-end fl-title ps-2">
                                                                            <div className="fw-bold">{`${origin} - ${destination}`}</div>
                                                                            <div className="text-sm">
                                                                                <span className="text-danger fw-bold">{selectedSeatsCount}</span> of {totalSelectMeals} Seats selected
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        key={flightIndex}
                                                    >
                                                        <AirplaneSeatTripjack
                                                            totalSelectedTravellers={totalSelectMeals}
                                                            rowsByFlight={rowsByFlight}
                                                            legends={transformedLegends}
                                                            selectedSeats={selectedSeatsReturn}
                                                            onClick={handleSeatClickReturn}
                                                            skipSeats={handleSkipSeats}
                                                            flightInfo={flightInfo}
                                                        />
                                                    </TabPane>
                                                );
                                            })}
                                        </Tabs>

                                    </TabPane>
                                )}

                                {flightDetails?.tripInfos?.[1]?.sI?.[0]?.ssrInfo?.MEAL?.length && (
                                    <TabPane
                                        tab={<h4 className="mb-1"> <FaBowlRice className="AddonsIcon" /> Meals</h4>}
                                        key="2"
                                        className='mb-0'
                                    >
                                        {flightDetails?.tripInfos?.[1]?.sI?.ssrInfo?.MEAL?.length !== 0 && (
                                            <Tabs
                                                defaultActiveKey="0"
                                                className="meal-tabs"
                                                type="card"

                                                tabBarExtraContent={
                                                    <button
                                                        style={{ background: "transparent", border: "none" }}
                                                        onClick={handleSkipMealsReturn}
                                                        className="btn btn-light text-danger"
                                                    >
                                                        <b>Skip Meals</b>
                                                    </button>
                                                }
                                            >
                                                {flightDetails?.tripInfos?.[1]?.sI.map((flightInfo, flightIndex) => {
                                                    const segmentList = flightDetails?.tripInfos?.[0]?.sI;
                                                    return (
                                                        <TabPane
                                                            tab={
                                                                // segmentList?.length > 1 ? (
                                                                <div className="mb-0">
                                                                    <div className="card-body p-2">
                                                                        <div className="d-flex justify-content-start">
                                                                            <div className="d-end fl-title ps-2">
                                                                                <div className="fw-bold">
                                                                                    {`${flightInfo?.da?.city || ''} - ${flightInfo?.aa?.city || ''}`}
                                                                                </div>
                                                                                <div className="text-sm">
                                                                                    <span className="text-danger fw-bold">
                                                                                        {selectedMealsReturn?.[flightIndex]?.selectedMealsReturn?.length || 0}
                                                                                    </span>{" "}
                                                                                    of {totalSelectMeals} Meals selected
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                // ) : null
                                                            }
                                                            key={flightIndex}
                                                        >
                                                            {flightInfo?.ssrInfo?.MEAL?.length > 0 && (
                                                                <>
                                                                    {/* {segmentList?.length <= 1 && (<div className="card">
                                                                        <div className="card-body p-2">
                                                                            <div className="d-flex justify-content-start">
                                                                                <div className="d-start fl-pic">
                                                                                    <img
                                                                                        className="img-collection result-flight"
                                                                                        src={`https://d1mmwnce2x2c2z.cloudfront.net/airline/${flightInfo?.fD?.aI?.code}.gif`}
                                                                                        alt="logo"
                                                                                    />
                                                                                </div>
                                                                                <div className="d-end fl-title ps-2">
                                                                                    <div className="text-dark fw-bold">
                                                                                        {flightInfo?.da?.city} - {flightInfo?.aa?.city}
                                                                                    </div>
                                                                                    <div className="text-sm text-muted">
                                                                                        <span className="text-danger">
                                                                                            {selectedMealsReturn?.[flightIndex]?.selectedMealsReturn?.length || 0}
                                                                                        </span>{" "}
                                                                                        of <span className="text-dark">{totalSelectMeals}</span> Meals selected
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>)} */}

                                                                    <div className="overflow-auto p-2 border rounded" style={{ maxHeight: "260px" }}>
                                                                        {flightInfo?.ssrInfo?.MEAL.map((meal, mealIndex) => (
                                                                            <div className="d-flex align-items-center justify-content-between mb-3" key={mealIndex}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <div className="bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1">
                                                                                        <svg fill="#ffffff" height="20px" width="20px" version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_3_" d="M198.5,127h56.8c-3.1,51.4-36.3,94.5-82.3,111.7V256H83v-17.3C37,221.5,3.8,178.4,0.7,127h155.1l87.5-68.1 c3.5-2.7,8.5-2.1,11.2,1.4s2.1,8.5-1.4,11.2c-0.1,0.1-0.3,0.2-0.4,0.3l-81,55.1l73-36.2c4-2,8.8-0.3,10.7,3.6c2,4,0.3,8.8-3.6,10.7 c-0.2,0.1-0.3,0.2-0.5,0.2L198.5,127z M163.6,79.4c0,7.8,3.2,12,5.7,15.3c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1 c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9 c2.5-3.3,5.7-7.5,5.7-15.3s-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9 c0,4.8-1.6,6.9-3.9,9.9C166.7,67.4,163.6,71.6,163.6,79.4z M115.7,71c0,11.2,4.4,16.9,8.3,22c1.2,1.5,2.2,2.9,3.2,4.5 c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-1.2-1.9-2.5-3.6-3.7-5.2c-3.4-4.5-6.4-8.4-6.4-16.5 s3-12,6.4-16.5c3.9-5.1,8.3-10.8,8.3-22c0-11.1-4.4-16.9-8.3-22l-0.7-0.9c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.7,1 c3.4,4.5,6.4,8.4,6.4,16.5c0,8.1-3,12-6.4,16.5C120.1,54.1,115.7,59.9,115.7,71z M72.9,79.4c0,7.8,3.2,12,5.7,15.3 c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5 c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9c2.5-3.3,5.7-7.5,5.7-15.3c0-7.8-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9 c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9c0,4.8-1.6,6.9-3.9,9.9C76.1,67.4,72.9,71.6,72.9,79.4z"></path> </g></svg>
                                                                                    </div>
                                                                                    <div className="ms-2">
                                                                                        <h4 className="mb-0 line-height">{meal?.desc}</h4>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="d-flex align-items-center addons_button">
                                                                                    <div className="fw-bold">₹{meal?.amount}</div>
                                                                                    <Button
                                                                                        className="btn btn-danger py-0 px-md-4 rounded ms-2"
                                                                                        onClick={() => removeMealReturn(flightIndex, mealIndex, meal.amount, flightInfo)}
                                                                                        disabled={!selectedMealsReturn?.[flightIndex]?.selectedMealsReturn?.some(selected => selected.mealIndex === mealIndex)}
                                                                                        aria-label="remove meal"
                                                                                    >
                                                                                        -
                                                                                    </Button>
                                                                                    <span className="ms-2">
                                                                                        {selectedMealsReturn?.[flightIndex]?.selectedMealsReturn?.filter(selected => selected.mealIndex === mealIndex).length || 0}
                                                                                    </span>

                                                                                    <Button
                                                                                        className="btn btn-primary py-0 px-md-4 rounded ms-2"
                                                                                        onClick={() => addMealReturn(flightIndex, mealIndex, meal.amount, meal, flightInfo)}
                                                                                        disabled={selectedMealsReturn?.[flightIndex]?.selectedMealsReturn?.length >= totalSelectMeals}
                                                                                        aria-label="add meal"
                                                                                    >
                                                                                        +
                                                                                    </Button>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                                </>
                                                            )}
                                                        </TabPane>

                                                    );
                                                })}
                                            </Tabs>
                                        )}
                                    </TabPane>
                                )}

                                {(flightDetails?.tripInfos?.[1]?.sI[0]?.ssrInfo?.BAGGAGE || []).length && (
                                    <TabPane
                                        tab={<h4 className="mb-1"><FaSuitcaseRolling className="AddonsIcon" /> Baggage (Return)</h4>}
                                        key="3"
                                    >
                                        {(flightDetails?.tripInfos?.[1]?.sI[0]?.ssrInfo?.BAGGAGE || []).length !== 0 &&
                                            <>
                                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                                    <div className='card'>
                                                        <div className='card-body p-2'>
                                                            <div className="d-flex justify-content-start">
                                                                <div className="d-end fl-title ps-2">
                                                                    <div className="text-dark fw-bold">{flightDetails?.tripInfos?.[1]?.daCity} - {flightDetails?.tripInfos?.[1]?.aaCity}</div>
                                                                    <div className="text-sm text-muted"><span className="text-danger">{totalSelectedBaggagesReturn}</span> of <span className="text-dark">{totalSelectMeals}</span> baggage selected</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <button
                                                        style={{ background: "transparent", border: "none" }}
                                                        onClick={handleSkipBaggageReturn}
                                                        className="btn btn-light text-danger"
                                                    >
                                                        <b>Skip Baggages</b>
                                                    </button>
                                                </div>

                                                <div className="overflow-auto p-2 border rounded" style={{ maxHeight: "260px" }}>
                                                    {flightDetails?.tripInfos?.[1]?.sI?.[0]?.ssrInfo?.BAGGAGE?.map((baggage, i) => (
                                                        <div className="d-flex align-items-center justify-content-between mb-3" key={i}>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='bg-primary py-md-2 px-md-3 py-1 px-1 rounded lh-1'>
                                                                    <FaSuitcase className='text-white fs-4' />
                                                                </div>
                                                                <div className='ms-2'>
                                                                    <h4 className='mb-0 line-height'>{baggage?.desc}</h4>
                                                                </div>
                                                            </div>
                                                            <div className='d-flex align-items-center addons_button'>
                                                                <div className='fw-bold'>₹{baggage?.amount}</div>
                                                                <Button
                                                                    className='btn btn-danger py-0 px-md-4 rounded ms-2'
                                                                    onClick={() => removeBaggageReturn(baggage, flightDetails?.tripInfos)}
                                                                >
                                                                    -
                                                                </Button>

                                                                <span className="ms-2">
                                                                    {
                                                                        selectedBaggagesReturn.filter(
                                                                            item =>
                                                                                item.code === baggage.code &&
                                                                                item.origin === flightDetails?.tripInfos?.[1]?.sI?.[0]?.da?.code &&
                                                                                item.destination === flightDetails?.tripInfos?.[1]?.sI?.[0]?.aa?.code
                                                                        ).length
                                                                    }
                                                                </span>

                                                                <Button
                                                                    className='btn btn-primary py-0 px-md-4 rounded ms-2'
                                                                    onClick={() => addBaggageReturn(baggage, flightDetails?.tripInfos)}
                                                                    disabled={selectedBaggagesReturn.length >= totalSelectMeals}
                                                                >
                                                                    +
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                        }

                                    </TabPane>
                                )}

                            </Tabs>
                        </>
                    }

                </div>
            </div>
        </>
    )
}


export default AddonsFlightTripJack